module.exports = __webpack_public_path__ + "img/app_icon_14.dd97e99c.png";